module.exports = "./images/home-vrmarket-img@2x.png?14f6ba4fc80237a4bf49a065dc206460";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-vrmarket-img@2x.png
// module id = 37
// module chunks = 0